import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker (enables PWA install prompts on desktop & Android).
// Skips localhost:3000 dev unless the user explicitly opts in, because HMR + SW
// caches don't play nicely together.
if ('serviceWorker' in navigator) {
  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  if (!isLocalhost || window.location.port !== '3000') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {
        /* silent — SW isn't critical to the app running */
      });
    });
  }
}
